import React from 'react';
import { Paper, Group, Stack, rem } from '@mantine/core';
import { ThemedText } from '../Typography';
import { SearchResult, getSearchResultIcon, getEventDescriptionColor } from './utils/searchHelpers';

interface SearchResultItemProps {
  result: SearchResult;
  isMobile: boolean;
  onClick: () => void;
}

const SearchResultItem: React.FC<SearchResultItemProps> = ({ result, isMobile, onClick }) => {
  const handleMouseEnter = (e: React.MouseEvent<HTMLDivElement>) => {
    e.currentTarget.style.backgroundColor = '#EA580C20';
  };

  const handleMouseLeave = (e: React.MouseEvent<HTMLDivElement>) => {
    e.currentTarget.style.backgroundColor = '#75757550';
  };

  return (
    <Paper
      p={isMobile ? rem(12) : rem(12)}
      radius="md"
      style={{
        backgroundColor: '#75757520',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        maxWidth: '100%',
        boxSizing: 'border-box',
        borderRadius: rem(8),
      }}
      onClick={onClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Group align="flex-start" gap="8px" wrap="nowrap">
        <div style={{ marginTop: rem(2), flexShrink: 0 }}>{getSearchResultIcon(result, 24)}</div>
        <Stack gap="4px" style={{ flex: 1, minWidth: 0 }}>
          <ThemedText
            size="sm"
            fw={500}
            truncate
            style={{
              fontSize: rem(14),
              lineHeight: rem(20),
            }}
          >
            {result.title}
          </ThemedText>
          <ThemedText
            size="xs"
            lineClamp={2}
            style={{
              fontSize: rem(10),
              lineHeight: rem(14),
              opacity: 0.8,
            }}
          >
            {result.type === 'upcoming_event' ? `🟠 ${result.description}` : result.description}
          </ThemedText>
        </Stack>
      </Group>
    </Paper>
  );
};

export default SearchResultItem;
